import { render, staticRenderFns } from "./carousItem.vue?vue&type=template&id=274c3baa&scoped=true"
import script from "./carousItem.vue?vue&type=script&lang=ts"
export * from "./carousItem.vue?vue&type=script&lang=ts"
import style0 from "./carousItem.vue?vue&type=style&index=0&id=274c3baa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_3bbe12a2a332147dfeceaba3e069e538/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274c3baa",
  null
  
)

export default component.exports